<template>
  <va-create-layout>
    <water-supply-form :title="title" :item="item"></water-supply-form>
  </va-create-layout>
</template>

<script>
export default {
  props: ['title', 'item'],
}
</script>
